<template>
  <div class="member_auth">
    <div class="module_title">
      <img src="../img/module_title.png" alt />
    </div>
    <div class="display_auth">
      <div class="auth_tab">
        <div class="kuaikan_tab" @click="switchTab('kuaikan')">
          <div class="kuaikan_tab_unchosen">
            <img src="../img/kuaikan_tab_unchosen.png" alt />
          </div>
          <div class="kuaikan_tab_chosen" v-show="chosen_tab == 'kuaikan'">
            <img src="../img/kuaikan_tab_chosen.png" alt />
          </div>
        </div>
        <div class="other_tab" @click="switchTab('other')">
          <div class="other_tab_unchosen">
            <img src="../img/others_tab_unchosen.png" alt />
          </div>
          <div class="other_tab_chosen" v-show="chosen_tab == 'other'">
            <img src="../img/others_tab_chosen.png" alt />
          </div>

          <div class="gift_tag">赠送{{plat_icons.length}}家</div>
        </div>
      </div>

      <div class="auth_content">
        <div
          class="auth_slide slide_left"
          :class="{ slide_right: chosen_tab == 'other' }"
        >
          <div class="slide_item">
            <kuaikan-auth v-if="chosen_tab == 'kuaikan'"></kuaikan-auth>
          </div>
          <div class="slide_item">
            <other-auth></other-auth>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
// comp
import KuaikanAuth from "../comp/KuaikanAuth";
import OtherAuth from "../comp/OtherAuth";

const { log } = console;
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["chosen_tab", "comp_init","plat_icons"]),
  },
  watch: {
    comp_init: function () {
      if (this.comp_init) {
        // 页面滚动到指定tab
        this.pageScroll();
      }
    },
  },
  components: {
    KuaikanAuth,
    OtherAuth,
  },
  mounted: function () {},
  methods: {
    ...mapMutations(["SET_CHOSEN_TAB"]),
    // 切换tab
    switchTab(item) {
      if (item == this.chosen_tab) return false;
      this.chosen_tab == "kuaikan"
        ? this.SET_CHOSEN_TAB("other")
        : this.SET_CHOSEN_TAB("kuaikan");

      let map = { kuaikan: "快看漫画特权", other: "其他应用特权" };
      
      this.$doTrack({ name: map[item] });
    },
    // 页面滚动到指定tab
    pageScroll() {
      let scrollTab = this.$kkmh.qs()["tab"]; // 1-快看权益 2-其他权益
      if (scrollTab == undefined) {
        return;
      }
      let obj = {
        1: "kuaikan",
        2: "other",
      };
      this.switchTab(obj[scrollTab]);
      
      // 页面滚动到tab处取消
      // let ele = document.querySelector(".member_auth");
      // let ele_top = ele.getBoundingClientRect().top;
      // window.scrollTo(0, ele_top);
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../css/common.scss";
.member_auth {
  margin-top: trans(42);
}
.module_title {
  @include boxsize(476, 77);
  margin: 0 auto;
  img {
    display: block;
    width: 100%;
  }
}
.display_auth {
  width: trans(710);
  margin: 0 auto;
  margin-top: trans(30);
}
.auth_tab {
  @include boxsize(710, 122);
  @include layout(space-between, center);
  background-color: red;
  border-radius: trans(30) trans(30) 0 0;
  .kuaikan_tab,
  .other_tab {
    @include boxsize(355, 122);
    position: relative;
  }
  .kuaikan_tab_unchosen,
  .other_tab_unchosen {
    @include layout(center, flex-start);
    width: trans(355);
    position: absolute;
    img {
      @include boxsize(179, 30);
      margin-top: trans(24);
      display: block;
    }
  }
  .kuaikan_tab_chosen,
  .other_tab_chosen {
    @include layout(center, flex-start);
    @include boxsize(383, 122);
    background-color: #fee552;
    border-radius: trans(30) trans(50) 0 0;
    position: absolute;
    top: trans(-10);
    img {
      @include boxsize(241, 38);
      margin-top: trans(24);
      display: block;
    }
  }
  .other_tab_chosen {
    border-radius: trans(50) trans(30) 0 0;
    right: 0;
  }
  .gift_tag {
    @include boxsize(140, 30);
    @include fontstyle(#fee551, 22);
    @include layout(center, center);
    position: absolute;
    right: trans(20);
    top: trans(-20);
    background-color: #422222;
    border-radius: trans(18) trans(15) trans(15) trans(4);
    font-weight: bold;
  }
}
.auth_content {
  width: trans(710);
  min-height: trans(200);
  background: #fff;
  border-radius: trans(30) trans(30) trans(50) trans(50);
  margin-top: trans(-50);
  overflow: hidden;
  // position: relative;
  transform: rotate(0deg); // 解决border-radius存在时overflow:hideen失效的问题
  .auth_slide {
    @include layout(flex-start, flex-start);
    flex-wrap: nowrap;
    width: 200%;
    transition: all 0.2s ease-in-out;
    background-color: #fff;
  }
  .slide_left {
    transform: translate(0);
  }
  .slide_right {
    transform: translate(-50%);
  }
  .slide_item {
    width: trans(710);
    background-color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202010/unit_member/comp/MemberAuth.vue